import { StatsigUser } from '@statsig/js-client';
import { useCallback } from 'react';

import { logger } from '../datadog/logger';
import { Statsig } from './StatsigProvider';

export function useGracefullyUpdateStatsigUserCallback() {
  return useCallback(async (user: StatsigUser) => {
    try {
      await Statsig.updateUserAsync(user);
    } catch (error) {
      logger.error('Failed to update Statsig user', user, error as Error);
    }
  }, []);
}
